import { pagination_params } from '@/shared/utils/pagination_params';

const append = (path, key, val) => {
  if (val === undefined || val === null || val === '') return path;
  return `${path ? `${path}&` : ''}${key}=${encodeURIComponent(val)}`;
};

const appendCsv = (path, key, arr) => {
  const list = (arr || [])
    .map((v) => (typeof v === 'object' ? v?.Codigo : v))
    .filter((v) => v !== undefined && v !== null && `${v}` !== '');
  if (!list.length) return path;
  return append(path, key, list.join(','));
};

export const getParamsUrl = (params = {}) => {
  let path = '';
  path = pagination_params(params);

  path = append(path, 'Codigo', params.Codigo);
  path = append(path, 'CodigoAdicional', params.CodigoAdicional);
  path = append(path, 'categoria', params.CodigoMaterialCategoria);
  path = append(path, 'codigoFamilia', params.CodigoFamilia);
  path = append(path, 'DescripcionInterna', params.DescripcionInterna);
  path = append(path, 'CodigoElementoGrupo', params.CodigoElementoGrupo);
  path = append(path, 'TipoMaterial', params.TipoMaterial);
  path = append(path, 'filtroGenerico', params.filtroGenerico);
  if (!Array.isArray(params.tipos)) {
    params.tipos = [params.tipos];
  }
  if (!Array.isArray(params.MaterialTipos)) {
    params.MaterialTipos = [params.MaterialTipos];
  }
  path = appendCsv(path, 'tipos', params.tipos?.length ? params.tipos : params.MaterialTipos);

  if (!Array.isArray(params['tipos.ne'])) {
    params['tipos.ne'] = [params['tipos.ne']];
  }
  path = appendCsv(path, 'tipos.ne', params['tipos.ne']);

  path = appendCsv(
    path,
    'codigosFamilia',
    params.codigosFamilia?.length ? params.codigosFamilia : params.Familias,
  );

  return path;
};
